import { useMultiStepFormStore } from "@/stores";
import { Button } from "@/ui";
import { TOTAL_FORM_STEPS } from "@/utils";

interface FormButtonsProps {
  isNextDisabled?: boolean;
  isSubmitting?: boolean;
  onSubmitOverride?: () => void;
}

const getButtonLabel = (currentFormStep: number) => {
  if (currentFormStep === TOTAL_FORM_STEPS) return "Transfer patient";
  if (currentFormStep === TOTAL_FORM_STEPS - 1) return "Submit form";
  return "Next";
};
const FormButtons = ({
  isNextDisabled,
  isSubmitting,
  onSubmitOverride,
}: FormButtonsProps) => {
  const { goToPreviousFormStep, currentFormStep } = useMultiStepFormStore();
  return (
    <div className="col-span-2 flex justify-between pb-24">
      <Button
        variant="secondary"
        onClick={() => goToPreviousFormStep()}
        className={"w-3/12"}
        disabled={isSubmitting}
      >
        Back
      </Button>
      <Button
        variant="primary"
        type={onSubmitOverride ? "button" : "submit"}
        onClick={onSubmitOverride}
        className={"w-3/12"}
        disabled={isNextDisabled ?? isSubmitting}
        isLoading={isSubmitting}
      >
        {getButtonLabel(currentFormStep)}
      </Button>
    </div>
  );
};

export default FormButtons;
